import { Mark } from "@tiptap/core";

export default Mark.create({
    name: "label",

    addAttributes() {
        return {
            class: {
                default: "custom-label",
            },
        };
    },

    parseHTML() {
        return [{ tag: "span.custom-label" }];
    },

    renderHTML({ HTMLAttributes }) {
        return ["span", { ...HTMLAttributes }, 0];
    },

    addCommands() {
        return {
            setLabel: () => ({ commands }) => {
                return commands.setMark(this.name);
            },
            unsetLabel: () => ({ commands }) => {
                return commands.unsetMark(this.name);
            },
        };
    },
});